import React from 'react';
import Grid from '@material-ui/core/Grid';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Input from '@material-ui/core/Input';

import Select from '../../components/Select/Select';
import Pagination from "material-ui-flat-pagination";
import Category from './Category/Category';

import Loading from '../../components/Loading/Loading';
import * as actions from '../../store/actions';
import { animateScroll } from 'react-scroll';

import { connect } from 'react-redux';

const statuses = [
    {
        label: "Aktif",
        value: 1,
    },
    {
        label: "Pasif",
        value: 0,
    },
]

const sortingList = [
    {
        label: "Video Sayısı (Azalan)",
        value: "videosCountDesc",
    },
    {
        label: "Video Sayısı (Artan)",
        value: "videosCountAsc",
    },
    {
        label: "En Popüler",
        value: "popularPoint",
    },
    {
        label: "A-Z",
        value: "nameAsc",
    },
    {
        label: "Z-A",
        value: "nameDesc",
    },
]


class Categories extends React.Component {

    state = {
        filters: {
            title: "",
            status: null,
            sort: null,
        },
    }

    filterChangeHandler = (name, val) => {
        let filters = { ...this.state.filters, [name]: val };
        this.setState({
            filters: filters
        });

    }

    resetAllFilters = () => {
        const filters = {
            ...this.state.filters
        }
        Object.keys(filters).forEach(f => {
            filters[f] = typeof filters[f] === "string" ? "" : null;
        });

        this.setState({
            filters: filters
        });

        this.props.onResetAllFilters();
    }

    paginationClickHandler = (offset) => {
        const paginationVal = { ...this.state.pagination, offset: offset }
        this.setState({
            pagination: paginationVal,
        });
    }

    filterCategories = e => {
        e.preventDefault();
        const filters = {
            ...this.state.filters
        };
        this.props.onFilterCategories(filters);
    }


    componentDidMount() {
        if (this.props.activeDomain.id) {
            this.props.onGetCategories();
        }
        this.setState({
            filters: this.props.filters
        });

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.activeDomain.id !== null && prevProps.activeDomain.id !== null && this.props.activeDomain !== prevProps.activeDomain) {
            this.props.onChangeDomain();
        }
        if (this.props.categories.length < 1 && this.props.activeDomain.id !== null && prevProps.activeDomain.id == null) {
            this.props.onGetCategories();
        }

        return true;
    }

    render() {


        const categoriesHTML = this.props.categories.map(data => {
            return <Category {...data} key={data.id} />;
        });

        const loading = this.props.loading ? <Loading size={100} /> : null;

        return (
            <React.Fragment>
                {loading}
                <form onSubmit={this.filterCategories} className="GeneralFilter">
                    <ExpansionPanel expanded={this.props.filtersExpanded} onChange={this.props.onChangeFiltersExpanded} className="GeneralFilter" CollapseProps={{
                        classes: {
                            container: "GeneralFilterContainer",
                        }
                    }} classes={{ expanded: "GeneralFilterExpanded" }}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <h4 className="Title">Filtreler</h4>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="ExpansionDetails" >
                            <Grid container spacing={24}>


                                <Grid item xs={12} sm={4} >
                                    <Input
                                        placeholder="Başlık"
                                        inputProps={{
                                            'aria-label': 'Description',
                                        }}
                                        className="GeneralInput"
                                        fullWidth
                                        onChange={(e) => { this.filterChangeHandler("title", e.target.value) }}
                                        value={this.state.filters.title}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} >
                                    <Select
                                        changed={(val) => this.filterChangeHandler("status", val)}
                                        placeholder="Durum Seç"
                                        options={statuses}
                                        value={this.state.filters.status}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} >
                                    <Select
                                        changed={(val) => this.filterChangeHandler("sort", val)}
                                        placeholder="Sıralama Seç"
                                        options={sortingList}
                                        value={this.state.filters.sort}
                                    />
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                        <Divider />
                        <ExpansionPanelActions>
                            <Button size="small" onClick={this.resetAllFilters}>Sıfırla</Button>
                            <Button size="small" type="submit" color="primary" >
                                Uygula
                        </Button>
                        </ExpansionPanelActions>
                    </ExpansionPanel>
                </form>
                <Grid container className="GeneralLists" spacing={24}>
                    {categoriesHTML}
                </Grid>
                <Pagination
                    size="large"
                    limit={this.props.pagination.limit}
                    offset={this.props.pagination.offset}
                    total={this.props.pagination.total}
                    onClick={(e, offset) => this.props.onChangePagination(offset)}
                    classes={{
                        root: "paginationLists"
                    }}
                />
            </React.Fragment>
        );
    }

}

const mapStateToProps = state => {
    return {
        categories: state.category.filteredCategories.slice(state.category.pagination.offset, state.category.pagination.offset + state.category.pagination.limit),
        pagination: state.category.pagination,
        activeDomain: state.domain.activeDomain,
        loading: state.category.loading,
        filters: state.category.filters,
        filtersExpanded: state.category.filtersExpanded
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangePagination: (offset) => {
            animateScroll.scrollToTop({ containerId: "scrolledContent", duration: 500, })
            dispatch(actions.changeCategoryPagination(offset));
        },
        onChangeDomain: () => dispatch(actions.saveCategories()),
        onGetCategories: () => dispatch(actions.saveCategories()),
        onFilterCategories: (payload) => dispatch(actions.filterCategories(payload)),
        onResetAllFilters: () => dispatch(actions.resetAllCategoriesFilters()),
        onChangeFiltersExpanded: (e, expanded) => dispatch(actions.changeCategoryFiltersExpanded(expanded)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Categories);